export const update = {
  updateSuccessfully: 'Update terminal successfully!',
}
